import React from "react";
import { Placeholder } from "react-bootstrap";

const QuickActionsSkeleton = () => {
  return (
    <div className="d-flex gap-3">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="flex-fill text-center py-3 px-2 rounded-3 border bg-white"
        >
          <Placeholder as="div" animation="wave" className="mb-2">
            <Placeholder xs={8} className="rounded" />
          </Placeholder>
          <Placeholder as="div" animation="wave">
            <Placeholder xs={5} className="rounded" />
          </Placeholder>
        </div>
      ))}
    </div>
  );
};

export default QuickActionsSkeleton;
